import { IParams, tryFetch } from "../../helpers/FetchAPI"; 

export const tryAuthenticate = async (payload: any) => {
    let params: IParams = {
        url: '/login',
        method: "POST",
        payload
    }
    return await tryFetch(params);
}

export const tryRefresh = async (token: string) => {
    let params: IParams = {
        url: '/sec/refresh',
        method: "POST",
        token
    }
    return await tryFetch(params);
}

export const logout = async (token: string) => {
    let params: IParams = {
        url: '/sec/logout',
        method: "POST",
        token
    }
    return await tryFetch(params);
}

export const fetchProfile = async (token: string) => {
    let params: IParams = {
        url: '/sec/profile',
        method: "GET",
        token
    }
    return await tryFetch(params);
}

export const TryVerify =  async (token: string) => {
    let params: IParams = {
        url: `/verify/${token}`,
        method: "POST",
        payload: {},
    }
    return await tryFetch(params);
}

export const TryVerifyReset =  async (token: string) => {
    let params: IParams = {
        url: `/verify-reset/${token}`,
        method: "POST",
        payload: {},
    }
    return await tryFetch(params);
}

export const TryResetPassword =  async (payload:object, token: string) => {
    let params: IParams = {
        url: `/reset-password`,
        method: "POST",
        payload: payload,
        token
    }
    return await tryFetch(params);
}